export default __webpack_public_path__ + "./images/sj.5937d405.png";